var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.85455 2.67969C3.62141 2.91282 3.5437 3.30138 3.5437 3.76766V20.942C3.5437 21.4083 3.69913 21.7969 3.93226 22.03L4.00997 22.1077L13.6463 12.4714V12.316L3.85455 2.67969Z",
    fill: "url(#paint0_linear_2721_96201)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7548 15.7383L13.5686 12.5521V12.319L16.7548 9.13281L16.8325 9.21052L20.6404 11.3865C21.7284 12.0082 21.7284 13.0184 20.6404 13.6401L16.7548 15.7383Z",
    fill: "url(#paint1_linear_2721_96201)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8322 15.6467L13.5683 12.3828L3.85425 22.0968C4.24281 22.4854 4.78679 22.4854 5.4862 22.1745L16.8322 15.6467Z",
    fill: "url(#paint2_linear_2721_96201)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8322 9.12743L5.4862 2.67733C4.78679 2.28877 4.24281 2.36649 3.85425 2.75505L13.5683 12.3913L16.8322 9.12743Z",
    fill: "url(#paint3_linear_2721_96201)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.7544 15.5781L5.4862 21.9505C4.86451 22.3391 4.32052 22.2614 3.93196 21.9505L3.85425 22.0282L3.93196 22.1059C4.32052 22.4168 4.86451 22.4945 5.4862 22.1059L16.7544 15.5781Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M3.85455 21.9414C3.62141 21.7083 3.5437 21.3197 3.5437 20.8534V20.9311C3.5437 21.3974 3.69913 21.786 3.93226 22.0191V21.9414H3.85455ZM20.6404 13.3931L16.7547 15.569L16.8325 15.6467L20.6404 13.4708C21.1843 13.1599 21.4175 12.7714 21.4175 12.3828C21.4175 12.7714 21.1066 13.0822 20.6404 13.3931Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M5.4865 2.75032L20.6404 11.3764C21.1066 11.6872 21.4175 11.9981 21.4175 12.3866C21.4175 11.9981 21.1843 11.6095 20.6404 11.2986L5.4865 2.67261C4.39853 2.05092 3.5437 2.51719 3.5437 3.76058V3.83829C3.5437 2.67261 4.39853 2.12863 5.4865 2.75032Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2721_96201",
    x1: 12.7137,
    y1: 3.62,
    x2: -0.32869,
    y2: 16.6616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2721_96201",
    x1: 22.0656,
    y1: 12.3975,
    x2: 3.26166,
    y2: 12.3975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2721_96201",
    x1: 15.0658,
    y1: 14.1671,
    x2: -2.61994,
    y2: 31.8528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2721_96201",
    x1: 1.44284,
    y1: -3.0143,
    x2: 9.34072,
    y2: 4.88358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.368b13329f80bd6cbf54ed0a850eee28.svg";
export { ForwardRef as ReactComponent };